import { LoadingStatus, Order, OrderFilterData } from '@api/types';
import { Column, SmartLink, StyledTableRow, StyledTableRowSeparator, TableCell } from '@components';
import { useAppSelector } from '@hooks';

import { getSpecialPage } from '@store/app/app.slice';

import { t } from '@translations';

import { getOrderItems } from './OrderListItem.config';

export type OrderListItemProps = LoadingStatus & {
  order: Order;
  filters?: OrderFilterData;
  filteredColumns?: Array<Column>;
  visibleColumnNames?: Array<string>;
  isWorking?: boolean;
};

/***
 * Order List - single order
 */
export const OrderListItem = ({
  order,
  isWorking,
  visibleColumnNames,
  filteredColumns,
  filters,
}: OrderListItemProps) => {
  const orderDetailsBaseUrl = useAppSelector(getSpecialPage('orderDetailsPage'));
  const orderDetailsHref = `${orderDetailsBaseUrl}?id=${order.vismaOrderNumber}`;
  const orderType = t('OrderTypesLocalization.' + order.orderType);
  const orderStatus = t(order.erpStatus);
  const orderItems = getOrderItems(order, orderType, orderStatus);
  const searchWords = filters?.Search?.split(' ') ?? [];

  return (
    <StyledTableRow iscursorpointer='true'>
      <SmartLink href={orderDetailsHref} sx={{ display: 'contents', p: 8 }} className='link'>
        {orderItems.map((orderItem) => (
          <TableCell
            key={orderItem.fieldName}
            isWorking={isWorking}
            visibleColumnNames={visibleColumnNames}
            filteredColumns={filteredColumns}
            searchWords={searchWords}
            {...orderItem}
          />
        ))}
        <StyledTableRowSeparator />
      </SmartLink>
    </StyledTableRow>
  );
};
